<template>
  <div class="toast">
    <div class="toast-content-body">
      <div class="content-icon">
        <div class="loading" data-width="16">
          <toastLoading></toastLoading>
          <!-- <svg width='16px' height='16px' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='8' cy='8' r='6' stroke='rgba(255,255,255,0.5)' fill='none' stroke-width='3'>
            </circle>
            <circle cx='8' cy='8' r='6' stroke-dasharray='20 32' stroke-dashoffset='32' stroke='#fff' fill='none' stroke-width='3'></circle>
          </svg>-->
        </div>
      </div>
      <div class="content-dialog">{{$t('loading')}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import toastLoading from '../../assets/svg/toast_loading.svg'
export default {
  name: 'toast',
  props: {
    type: String,
    onChange: Function
  },
  components: {
    toastLoading
  },
  computed: {
    ...mapState({
      toastStatus: state => state.app.toastStatus
    })
  }
}
</script>

<style lang="scss" scoped>
.toast {
  width: 210px;
  height: 60px;
  background-color: #125ed2;
  border-radius: 6px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
  color: #ffffff;
  z-index: 1003;
  position: absolute;
  top: 10px;
  left: calc(50% - 105px);
  user-select: none;
  .toast-content-body {
    height: 60px;
    padding: 15px 30px;
    display: flex;
    .content-dialog {
      line-height: 30px;
      margin-left: 17px;
    }
  }
  svg {
    width: 30px;
    height: 30px;
    .white_line {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(0deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(0deg) translate(-43.98708915710449px, -44.980445861816406px);
      -webkit-animation-name: kf_white_line_body;
      animation-name: kf_white_line_body;
      -webkit-animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }
    .green_line {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
      -webkit-animation-name: kf_green_line_body;
      animation-name: kf_green_line_body;
      -webkit-animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }
    .dark_green_line {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
      -webkit-animation-name: kf_dark_green_line_body;
      animation-name: kf_dark_green_line_body;
      -webkit-animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }
    .orange_line {
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
      -webkit-animation-name: kf_orange_line_body;
      animation-name: kf_orange_line_body;
      -webkit-animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }
  }
  @-webkit-keyframes kf_white_line_body {
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(0deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(0deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(360deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(360deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @keyframes kf_white_line_body {
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(0deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(0deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(360deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(360deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @-webkit-keyframes kf_green_line_body {
    10% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(365deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(365deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @keyframes kf_green_line_body {
    10% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(365deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(365deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(5deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @-webkit-keyframes kf_dark_green_line_body {
    20% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(370deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(370deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @keyframes kf_dark_green_line_body {
    20% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(370deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(370deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(10deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @-webkit-keyframes kf_orange_line_body {
    27% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(375deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(375deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
  @keyframes kf_orange_line_body {
    27% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    100% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(375deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(375deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
    0% {
      -webkit-transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
      transform: translate(43.98708915710449px, 44.980445861816406px)
        rotate(15deg) translate(-43.98708915710449px, -44.980445861816406px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/Toast.vue